import { createAction, props } from '@ngrx/store';

import DirectoryContract = Microsoft.VideoIndexer.Contracts.DirectoryContract;

export const loadDirectories = createAction('[Directories] Load Directories');
export const loadDirectoriesSuccess = createAction('[Directories] Load Directories Success', props<{ directories: DirectoryContract[] }>());
export const loadDirectoriesFailed = createAction('[Directories] Load Directories Failed');
export const reloadDirectories = createAction('[Directories] Reload Directories');
export const selectDirectory = createAction('[Directories] Select Directory', props<{ tenantId: string }>());
